import { render, staticRenderFns } from "./ConveniosView.vue?vue&type=template&id=0b8e77f2&"
import script from "./ConveniosView.vue?vue&type=script&lang=ts&"
export * from "./ConveniosView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports